// axios
import axios from 'axios';
// routes
import {routes} from "../../features/routes/route";
// config
import {config} from "../../config/chargeConfig";

export const sendPaymentInfo2 = async (data: any) => {
    const {data: response} = await axios.post(routes.api[1].address_2, {
        key: String(data)
    }, config);
    return response.data;
};
